export default "__VITE_ASSET__12183327__"